import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { HorizonLogo } from './HorizonLogo';

const Footer = () => {
  const { t } = useTranslation();
  const scrollToSection = (href) => document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });

  const navItems = [
    { href: '#', label: t('footer.home') },
    { href: '#services', label: t('nav.services') },
    { href: '#work', label: t('nav.work') },
    { href: '#about', label: t('nav.about') },
    { href: '#pricing', label: t('nav.pricing') },
    { href: '#contact', label: t('nav.contact') },
  ];

  const serviceItems = [
    t('services.s1'), t('services.s2'), t('services.s3'), t('services.s4'),
  ];

  return (
    <footer data-testid="footer" className="bg-[#1A1816] py-12 text-[#FAF8F5]/70">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-8">
          <motion.div className="lg:col-span-4" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
            <div data-testid="footer-logo" className="origin-left scale-[0.85] sm:scale-100">
              <HorizonLogo dark animated />
            </div>
            <p className="mt-7 text-sm leading-relaxed max-w-sm text-[#FAF8F5]/50">
              {t('footer.desc')}
            </p>
          </motion.div>

          <motion.div className="lg:col-span-2" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.1 }}>
            <h3 className="text-xs font-semibold tracking-[0.2em] uppercase text-[#C9A96E] mb-4">{t('footer.nav')}</h3>
            <ul className="space-y-3">
              {navItems.map((item) => (
                <li key={item.href + item.label}>
                  <button onClick={() => scrollToSection(item.href)} className="text-[#FAF8F5]/50 hover:text-[#C9A96E] transition-colors text-sm">{item.label}</button>
                </li>
              ))}
            </ul>
          </motion.div>

          <motion.div className="lg:col-span-3" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.2 }}>
            <h3 className="text-xs font-semibold tracking-[0.2em] uppercase text-[#C9A96E] mb-4">{t('footer.services_title')}</h3>
            <ul className="space-y-3 text-[#FAF8F5]/50 text-sm">
              {serviceItems.map((s) => (
                <li key={s}>{s}</li>
              ))}
            </ul>
          </motion.div>

          <motion.div className="lg:col-span-3" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.3 }}>
            <h3 className="text-xs font-semibold tracking-[0.2em] uppercase text-[#C9A96E] mb-4">{t('footer.get_in_touch')}</h3>
            <ul className="space-y-3 text-[#FAF8F5]/50 text-sm">
              <li><a href="mailto:contact@horizondigitalagency.org" className="hover:text-[#C9A96E] transition-colors">contact@horizondigitalagency.org</a></li>
              <li>{t('footer.response')}</li>
            </ul>
          </motion.div>
        </div>

        <div className="mt-16 pt-6 border-t border-[#FAF8F5]/10 text-center text-xs text-[#FAF8F5]/30">
          &copy; {new Date().getFullYear()} Horizon Digital Agency. {t('footer.rights')}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
